export default "__VITE_ASSET__CQpFcAaT__"